"use client";

import React from "react";
import ContactForm from "../Components/contact/contact-form";

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Header */}
      <div className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Get in Touch
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Ready to start your next project? Let's discuss how we can help
              bring your ideas to life.
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
        <div className="grid grid-cols-1 lg:grid-cols-1 gap-8 lg:gap-12 items-start">
          {/* Left Column - Content */}
          {/* <div className="space-y-6 lg:space-y-8">
            <div>
              <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4 lg:mb-6">
                Let's Build Something Amazing Together
              </h2>
              <p className="text-base lg:text-lg text-gray-600 mb-6 lg:mb-8">
                Whether you have a clear vision or just a spark of an idea,
                we're here to help you turn it into reality. Our team
                specializes in creating innovative digital solutions that drive
                results.
              </p>
            </div>

            <div className="space-y-4 lg:space-y-6">
              <div className="flex items-start space-x-3 lg:space-x-4">
                <div className="flex-shrink-0 w-10 h-10 lg:w-12 lg:h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                  <svg
                    className="w-5 h-5 lg:w-6 lg:h-6 text-primary"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 10V3L4 14h7v7l9-11h-7z"
                    />
                  </svg>
                </div>
                <div>
                  <h3 className="text-base lg:text-lg font-semibold text-gray-900 mb-1 lg:mb-2">
                    Fast & Efficient
                  </h3>
                  <p className="text-sm lg:text-base text-gray-600">
                    Quick turnaround times with quality results. We understand
                    the importance of meeting deadlines.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-3 lg:space-x-4">
                <div className="flex-shrink-0 w-10 h-10 lg:w-12 lg:h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                  <svg
                    className="w-5 h-5 lg:w-6 lg:h-6 text-primary"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <div>
                  <h3 className="text-base lg:text-lg font-semibold text-gray-900 mb-1 lg:mb-2">
                    Quality Assured
                  </h3>
                  <p className="text-sm lg:text-base text-gray-600">
                    Every project is built with attention to detail and best
                    practices to ensure long-term success.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-3 lg:space-x-4">
                <div className="flex-shrink-0 w-10 h-10 lg:w-12 lg:h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                  <svg
                    className="w-5 h-5 lg:w-6 lg:h-6 text-primary"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </svg>
                </div>
                <div>
                  <h3 className="text-base lg:text-lg font-semibold text-gray-900 mb-1 lg:mb-2">
                    Expert Team
                  </h3>
                  <p className="text-sm lg:text-base text-gray-600">
                    Our experienced developers and designers work together to
                    deliver exceptional results.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-primary/5 rounded-xl p-4 lg:p-6">
              <h3 className="text-base lg:text-lg font-semibold text-gray-900 mb-2 lg:mb-3">
                Ready to Get Started?
              </h3>
              <p className="text-sm lg:text-base text-gray-600 mb-3 lg:mb-4">
                Fill out the form and we'll get back to you within 24 hours to
                discuss your project requirements.
              </p>
              <div className="flex items-center space-x-2 text-xs lg:text-sm text-gray-500">
                <svg
                  className="w-3 h-3 lg:w-4 lg:h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span>Response within 24 hours</span>
              </div>
            </div>
          </div> */}

          {/* Right Column - Form */}
          <div className="bg-white rounded-2xl shadow-xl p-6 lg:p-8">
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  );
}
